export function formatLanguage(name: string) {
  switch (name) {
    case 'csharp':
      return 'C#';
    case 'shell':
    case 'curl':
      return 'cURL';
    case 'http':
      return 'HTTP';
    case 'js':
    case 'javascript':
      return 'JavaScript';
    case 'java':
      return 'Java';
    case 'objectivec':
    case 'objc':
      return 'Objective-C';
    case 'swift':
      return 'Swift';
    default:
      return name;
  }
}
